module.exports = __webpack_public_path__ + "static/img/double-wall-outlet-mk-1_256.cee9f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-wall-outlet-mk-1_256.png
// module id = cbF4
// module chunks = 0